export default __webpack_public_path__ + "static/epilogue-c211f39133e2f85862a6b80147b7dc4e.svg";